<nb-card>
  <nb-card-header>
    <div class="title">
      Subscription Plans List
    </div>
    <div class="actions">
      <button nbButton type="submit" size="small"  class="add" (click)="addSubscriptionPlan()">
        <nb-icon icon="plus"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <ng2-smart-table class="subscriptions-smart-table" [settings]="settings" [source]="source" (edit)="onEdit($event)">
    </ng2-smart-table>
  </nb-card-body>
</nb-card>
